<template>
  <div class="press">
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true" :fullscreen="true" center :modal="mask" :show-close="false">
      <iframe height="100%" width="100%" :src="location"></iframe>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'drug',
  data() {
    return {
      mask: false,
      dialogVisible: true,
    }
  },
  computed: {
    location() {
      return window.location.origin + '/#/press1';
    }
  },
  components: {
    
  }
}
</script>

<style lang="scss" scoped>
.press {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/page1/press.vue